
import { Container, Filler } from './styles';

const ProgressBar: React.FC<React.PropsWithChildren<{ value: number; bgColor?: string }>> = props => {
  return (
    <Container>
      <Filler {...props}></Filler>
    </Container>
  );
};

export default ProgressBar;
